import { ComponentChildren } from "preact";

export function Locations(props: { children: ComponentChildren }) {
  return <div class="locations">{props.children}</div>
}

interface LocationProps {
  title: string;
  address: string;
  officeHours: string;
  phone: string;
  email: string;
  map: string;
}

export function Location(props: LocationProps) {
  return (
    <div class="location-box">
      <h3>{props.title}</h3>
      <p>
        {props.address.split("\n").map((line) => (
          <>
            {line}
            <br />
          </>
        ))}
      </p>

      <p>
        <strong>Office Hours:</strong>
        <br />
        {props.officeHours}
      </p>

      <p>
        <strong>Phone:</strong>
        <br />
        <a
          href={`tel:${props.phone.replaceAll(" ", "").replaceAll("(", "").replaceAll(
            ")",
            "",
          ).replaceAll("-", "")
            }`}
        >
          {props.phone}
        </a>
      </p>

      <p>
        <strong>E-Mail:</strong>
        <br />
        <a href={`mailto:${props.email}`}>{props.email}</a>
      </p>

      <iframe src={props.map}></iframe>
    </div>
  );
}
